export default [
    {
      header: 'Plateforme bénéficiaire',
      rights: [
        'PTF_BENEFICIAIRE:read',
        'PTF_BENEFICIAIRE_NEWS:read',
        'PTF_BENEFICIAIRE_DEMANDEACCES:read'
      ]
    },
    {
      title: 'Gérer les news',
      icon: 'BookIcon',
      route: 'news',
      rights: [
        'PTF_BENEFICIAIRE_NEWS:read'
      ]
    },
    {
      title: 'Gérer les rendez-vous',
      icon: 'CalendarIcon',
      route: 'manage-meetings',
      rights: [
        'PTF_BENEFICIAIRE_MEETINGS:read'
      ]
    },
    {
      title: 'Gérer les bénéficiaires',
      icon: 'UserIcon',
      route: 'manage-beneficiaires',
      rights: [
        'PTF_BENEFICIAIRE_BENEFICIAIRES:read',
        'PTF_BENEFICIAIRE_BENEFICIAIRES:admin',
        'PTF_BENEFICIAIRE_MES_BENEFICIAIRES:read'
      ]
    },
    {
      title: 'Gérer les demandes d\'accès',
      icon: 'BookIcon',
      route: 'demandesAcces',
      rights: [
        'PTF_BENEFICIAIRE_DEMANDEACCES:read'
      ]
    },
]